/**
 * The account token every map in the portal draws with.
 *
 * One copy. It was pasted into each map component in turn, and by the fifth the question "is this
 * the same token?" could only be answered by comparing eighty characters by eye — which is not a
 * question anybody should have to answer about a credential.
 *
 * Public by design: a Mapbox access token is sent to the browser on every tile request and is
 * restricted by URL on the account side, not by being hidden. Keeping it out of the environment is
 * deliberate — a build-time variable would suggest a secret and protect nothing.
 */
export const MAPBOX_TOKEN =
    'pk.eyJ1IjoibWFyY2dpbGxlc2VwZWhyaSIsImEiOiJjbTFoOWszeHQwYzR6MmpzYXh0OWo0cWF1In0.oCmn9LnN9lZavqGgDL_Y2w';
